// extracted by mini-css-extract-plugin
module.exports = {"questions":"aS","questionsTitle":"aT"};